//REVIEW
const SHIPPING_STATUS_COLOR_MAP = {
  WEB0000: 'turquoise', //Grabado
  WEB0500: 'yellow', //Recogido
  WEB1000: 'yellow', //En tránsito
  WEB1500: 'yellow', //En reparto
  WEB1600: 'red', // Incidencia en reparto
  WEB2000: 'green', //Entregado
}

export const getColorChipForStatus = status =>
  SHIPPING_STATUS_COLOR_MAP[status] ?? 'neutral'

const IN_PROGRESS_STATE = 'turquoise'
const COMPLETED_STATE = 'green'
const WITH_INCIDENT_STATE = 'primary'
const WITH_INCIDENT_STATE_SOLVABLE = 'orange'
const CANCELLED_STATE = 'red'
const UNSCHEDULED_PICK_UP = 'yellow'

export const getColorChipForStatusState = ({
  statusCode,
  incidentCode,
  isCancelled,
  isResolved,
  isUnscheduledPickup
}) => {
  //ÑAPA CODIGO WEB1600
  if(statusCode==='WEB1600') return WITH_INCIDENT_STATE
  if (isCancelled) return CANCELLED_STATE

  if (isResolved) return WITH_INCIDENT_STATE_SOLVABLE

  const hasIncident = Boolean(incidentCode)
  if (isUnscheduledPickup) return UNSCHEDULED_PICK_UP
  if (hasIncident) return WITH_INCIDENT_STATE
  
  return statusCode === 'WEB2000' ? COMPLETED_STATE : IN_PROGRESS_STATE
}
